









































































































import Vue from 'vue'
import { Action, Getter } from 'vuex-class'
import { Component, Watch } from 'vue-property-decorator'
import Loading from '@/components/Loading.vue'
import NPSBar from '@/components/NPSBar.vue'
import NPSBarLabel from '@/components/NPSBarLabel.vue'
import { formatGroupName } from '@/domain/TeamScoreboard'
import TsDatatypeSelector from './TsDatatypeSelector.vue'
import TsNpsCounts from './TsNpsCounts.vue'
import FormattedNumber from '@/components/FormattedNumber.vue'
import { TsGroupSummaryEntity } from '@/entities/teamscoreboard'

@Component<TsNpsScorecardV2>({
    components: {
        FormattedNumber,
        Loading,
        TsNpsCounts,
        NPSBar,
        NPSBarLabel,
        TsDatatypeSelector
    },
    filters: {
        formatGroupName
    }
})
export default class TsNpsScorecardV2 extends Vue {
    @Getter public tsScorecard
    @Getter public tsGroupSummary ?: TsGroupSummaryEntity
    @Getter public tsLoadingScorecard

    public viewOptions = ['COUNT', 'NPS']
    public viewSelected = 'COUNT'

    public mounted() {
        this.onTsScorecardReady()
    }

    public get showCounts() {
        return this.viewSelected === 'COUNT'
    }

    public get legendPositive() {
        if (this.showCounts) {
            return 'Positive feedback: '
        }
        return 'Above average'
    }

    public get legendNegative() {
        if (this.showCounts) {
            return 'Things to work on: '
        }
        return 'Below average'
    }

    public get scorecardGroups() {
        return this.tsScorecard.tsgroups.filter(
            ({responded, group}) => responded > 0 && group !== 'None'
        )
    }

    public getThingsToWorkOnCount(currentGroup) {
        return Number(currentGroup.responded - currentGroup.respondedPromoter)
    }

    public get totalPositiveCount() {
        return this.scorecardGroups.map(group => group.respondedPromoter).reduce((prev, curr) => parseInt(prev) + parseInt(curr), 0)
    }

    public get totalNegativeCount() {
        return this.scorecardGroups.map(group => group.responded).reduce((prev, curr) => parseInt(prev) + parseInt(curr), 0) - this.totalPositiveCount
    }

    @Watch('tsScorecard')
    private onTsScorecardReady() {

        if (!this.tsScorecard) {
            return
        }

        if (this.tsScorecard.isFiveScore) {
            this.viewOptions = ['COUNT', 'RATING']
        }
    }

    // for 100.0 and -100.0, no need to show ending .0
    getDisplayNps(nps) {
        if (Number(nps) === 100) {
            return 100
        } else if (Number(nps) === -100) {
            return -100
        } else {
            return nps
        }
    }
}
